import NavDropZone = require('./NavDropZone');
/**
 * Drop zone using a jquery ui droppable widget, for the navigation items
 * that are visible on the dropdown menu
 */

    class SubNavDropZone extends NavDropZone {
        private parentNavZone: NavDropZone;

        constructor(targetEl: JQuery) {
            super(targetEl, targetEl);
        }

        showInvitation(canDrop: boolean) {
            this.element.addClass(canDrop ? 'subnav-can-drop' : 'subnav-cannot-drop');
            this.getParentNavZone().element.addClass('nav-has-submenu');
        }

        hideInvitation() {
            this.element.removeClass('subnav-can-drop subnav-cannot-drop');
            this.getParentNavZone().element.removeClass('nav-has-submenu');
        }

        setParentNavZone(zone: NavDropZone) {
            this.parentNavZone = zone;
        }

        getParentNavZone() {
            return this.parentNavZone;
        }

        destroy() {
            this.setParentNavZone(null);
            super.destroy();
        }
    }

export = SubNavDropZone;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/SubNavDropZone.ts
 **/